import React from "react";
import { usePageTransition } from "../../../hooks/usePageLoad";
import "./PageLoadGate.css";

export default function PageLoadGate({
  skeleton,
  children,
  delay = 400,
  className = "",
  home = false,
}) {
  const { showSkeleton, showContent, isExiting, isReady } = usePageTransition(delay, {
    home,
  });

  return (
    <div className={`page-load-gate ${className}`}>
      {showSkeleton && (
        <div
          className={`page-load-skeleton ${isExiting ? "page-load-skeleton--exit" : ""}`}
          aria-hidden={isReady}
        >
          {skeleton}
        </div>
      )}
      {showContent && (
        <div
          className={`page-load-content ${
            isReady ? "page-load-content--visible" : "page-load-content--enter"
          }`}
        >
          {children}
        </div>
      )}
    </div>
  );
}
